<script>
    import Layout from "../../layouts/main";
    import PageHeader from "../../components/page-header";
    import producerBrandList from "./producer-brand-list";
    export default {
    components: { Layout, PageHeader, producerBrandList },
    data() {
        return {};
    }
    };

</script>

<template>
  <Layout>
    <producer-brand-list/>
  </Layout>
</template>